import {
  choiceInputClass,
  choiceLabelClass,
  describedBy,
  FieldError,
  HelpText,
  isRequiredNow,
  wrapperProps,
  type FieldProps,
} from "./shared";

/**
 * The port of fragments/forms/fields/checkbox.php: one box with its statement
 * beside it, for consents and confirmations.
 *
 * A checkbox submits nothing when it is clear, which validation reads as empty
 * - the "checkbox" validator type is written for exactly that. Its value here
 * is the field's value (or "1") while checked and "" while clear.
 */
export default function CheckboxField(props: FieldProps) {
  const { id, name, field, value, error, shown, onChange, onFocus } = props;

  if (!id || !name || !field) {
    return null;
  }

  const required = isRequiredNow(field, shown);
  const checkedValue = field.value || "1";

  return (
    <div {...wrapperProps(props)}>
      <div className="flex items-center gap-2.5">
        <input
          className={`${choiceInputClass} js-field-el`}
          type="checkbox"
          id={id}
          name={name}
          value={checkedValue}
          checked={value !== ""}
          required={required}
          aria-required={required || undefined}
          aria-invalid={!!error}
          aria-describedby={describedBy(id, field)}
          data-validate="1"
          data-required={required ? "1" : undefined}
          onChange={(event) =>
            onChange(name, event.target.checked ? checkedValue : "")
          }
          onFocus={() => onFocus(name)}
        />

        <label className={choiceLabelClass} htmlFor={id}>
          {field.label}
        </label>
      </div>

      <HelpText id={id} field={field} />

      <FieldError id={id} error={error} />
    </div>
  );
}
